import React from 'react';
import { SearchPopoverModal } from './SearchPopoverModal';
import SearchPopoverTrigger from './SearchPopoverTrigger';

const SearchInputModalTrigger = ({
  source,
  text,
  showHeaderSearchBar,
  useAlternativeStyle = false,
}: {
  source: string;
  text?: string;
  showHeaderSearchBar?: boolean;
  useAlternativeStyle?: boolean;
}) => {
  const [searchPopoverOpen, setSearchPopoverOpen] = React.useState(false);
  const handleSearchPopoverOnOpen = () => setSearchPopoverOpen(true);
  const handleSearchPopoverOnClose = () => setSearchPopoverOpen(false);
  return (
    <React.Fragment>
      <SearchPopoverTrigger
        text={text}
        onOpen={handleSearchPopoverOnOpen}
        showHeaderSearchBar={showHeaderSearchBar}
        useAlternativeStyle={useAlternativeStyle}
      />
      {searchPopoverOpen && (
        <SearchPopoverModal
          onClose={handleSearchPopoverOnClose}
          closeOnSubmit
          disableAnimation={false}
          source={source}
        />
      )}
    </React.Fragment>
  );
};

export default SearchInputModalTrigger;
